import { ReactNode } from 'react';
import { toast } from 'react-toastify';

export const ToastContent = ({
  title,
  message,
}: {
  title: string;
  message?: string | ReactNode;
}) => (
  <div>
    <h2 style={{ fontWeight: 700, fontSize: 14, marginBottom: '0.25rem' }}>
      {title}
    </h2>
    <p style={{ fontSize: 14 }}>{message}</p>
  </div>
);

export const appToast = {
  error: (errStatus = '', errMsg?: string | ReactNode) =>
    toast.error(<ToastContent title={errStatus} message={errMsg || ''} />),
  warning: (errStatus = '', errMsg?: string | ReactNode) =>
    toast.warning(<ToastContent title={errStatus} message={errMsg || ''} />),
  success: (errStatus = '', errMsg?: string | ReactNode) =>
    toast.success(<ToastContent title={errStatus} message={errMsg || ''} />),
  info: (errStatus = '', errMsg?: string | ReactNode) =>
    toast.info(<ToastContent title={errStatus} message={errMsg || ''} />),
};
